import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=015279dd&scoped=true&"
import script from "./ThankYouPage.vue?vue&type=script&lang=js&"
export * from "./ThankYouPage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "015279dd",
  null
  ,true
)

export default component.exports